import { IResult } from 'app/shared/models/result.model';
import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { of } from 'rxjs/observable/of';
import { IDtoJobCandidateBasic } from 'app/shared/models/employee/dto-jobcandidate-basic.model';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoEvent } from 'app/shared/models/incident/dto-event.model';
import { IDtoTicket } from 'app/shared/models/incident/dto-ticket.model';
import { IncidentService } from 'app/views/appviews/incident.service';
import { BsModalRef } from 'ngx-bootstrap';
import { StorageService } from 'app/shared/services/storage.service';
import { IDtoTicketResourceLocation } from 'app/shared/models/incident/dto-ticket-resource-location.model';
import { AppConfig } from 'app/app.config';
import { MessageService } from 'app/views/appviews/message.service';
import { IDtoMessageDetail } from 'app/shared/models/dto-message-detail.model';
import { IDtoTicketResource } from 'app/shared/models/incident/dto-ticket-resource.model';
import { EmployeeService } from 'app/views/appviews/employee.service';

@Component({
  selector: 'modal-incident',
  templateUrl: './modal.incident.template.html',
  styleUrls: ['./modal.incident.style.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class ModalIncidentComponent implements OnInit, AfterViewInit  {
  private title: string;
  private businessPhone: string;
  private accion: string;
  private eventId: number;
  private onClose: Subject<any>;
  private resourceLocation = {} as IDtoTicketResourceLocation;
  private resource = {} as IDtoTicketResource;
  private event = {} as IDtoEvent;
  private tiket = {} as IDtoTicket;
  private result: IResult;
  //private list: any[] = [];
  private listResources: IDtoTicketResource[];
  private listLocations: IDtoCatalog[];
  private errorReceived: boolean;
  private formModalIncident: FormGroup;
  employee = {} as IDtoJobCandidateBasic;
  location: IDtoTicketResourceLocation;
  @ViewChild('locationId', { static: false }) private locationId: ElementRef;
  constructor(private incidentService: IncidentService
    , private bsModalRef: BsModalRef
    , private storageService: StorageService
    , private formBuilder: FormBuilder
    , private messageService: MessageService
    , private employeeService: EmployeeService
    , private configGeneral: AppConfig) {
  }

  public ngOnInit(): void {
    let requisition = this.storageService.retrieve('requisition');
    this.onClose = new Subject();
    this.formModalIncident = this.formBuilder.group({
      ticketResourceId: [null, Validators.required],
      locationId: [requisition.customerId],
      txtDescripcion: [null, Validators.required]
    });
    
    this.initializeSelect();
    
  }
  ngAfterViewInit() {
    if (this.locationId != undefined) {
      (<any>this.locationId).setDisabledState(true);
    }
  }
  public onCancel(): void {
    this.bsModalRef.hide();
  }

  private initializeSelect() {
    this.incidentService.getCatalogResource().subscribe(resources => {
      this.listResources = resources;
    });
    this.incidentService.getCatalogLocations().subscribe(locations => {
      this.listLocations = locations;
    });
  }

  private onSelect(item: IDtoTicketResource) {
    if (item != null || item !== undefined) {
      let form = this.formModalIncident.value;
      if (form.locationId == null || form.ticketResourceId == null) {
        this.configGeneral.newToast('¡Error!', 'Seleccione los datos del formulario para poder continuar', 'error');
        return;
      }
      let res = this.listResources.find(r => r.ticketResourceId == form.ticketResourceId);

      this.location = res.ticketResourceLocations.find(r => r.locationId == form.locationId && r.ticketResourceId == form.ticketResourceId);
      if(this.location == null) {
        this.configGeneral.newToast('¡Error!', 'No existe una atención de ticket para la ubicación seleccionada. Seleccione otra ubicación', 'error');
        return;
      }
      this.resource = res;
      this.resourceLocation = this.location;
      this.event.title = res.description;
      this.tiket.title = res.description;
      this.tiket.ticketResourceId = res.ticketResourceId;
      //this.getResourceLocation();
    }
  }
  private getResourceLocation() {
    this.incidentService.getResourceLocation(this.resourceLocation.locationId, this.resourceLocation.ticketResourceId)
      .catch((err) => this.handleError(err))
      .subscribe((data) => {
        if(data.isCorrect) {
          this.resourceLocation = data.data as IDtoTicketResourceLocation;
          this.configGeneral.newToast('Éxito!', data.message, 'success');
        } else {
          this.configGeneral.newToast('¡Error!', data.message, 'error');
          this.resourceLocation = null;
        }
      });
  }
  private save(): void {
    if (this.formModalIncident.valid) {
      if (this.eventId > 0) {
        this.addTicket();
      } else {
        this.addEvent();
      }
    } else {
      this.configGeneral.newToast('Validación!', 'Capture todos los datos para poder continuar', 'warning');
    }
  }

  private addEvent(): Observable<IResult> {
    if (this.resource == null) {
      this.configGeneral.newToast('¡Error!', 'Seleccione una falla o incidente de la lista para poder continuar', 'error');
      return;
    }
    this.event.description = this.tiket.description;
    this.event.ownerEmpId = this.employee.id;
    this.event.status = 1;
    this.event.locationId = this.location.locationId;
    this.event.type = 'Incident';

    this.tiket.ticketSubCategoryId = this.resource.ticketSubCategoryId;
    this.tiket.ticketCategoryId = this.resource.ticketCategoryId;
    this.tiket.allocatorEmpId = this.resource.managerEmpId;

    this.tiket.assignedEmpId = this.resource.reviewerType == 'User' ? this.resourceLocation.managerEmpId : this.employee.bossId;
    this.tiket.locationId = this.location.locationId;
    this.tiket.ownerEmpId = this.employee.id;
    this.tiket.priority = 'Baja';
    this.tiket.status = 1;
    this.tiket.type = 'Incident';
    this.event.tickets = [];
    this.event.tickets.push(this.tiket);
    const addEventObservable = this.incidentService.addEvent(this.event);
    addEventObservable
      .subscribe(
        (x) => {
          this.result = x;
          if (this.result.isCorrect === true) {
            this.event = this.result.data as IDtoEvent;
            this.sendMessage(this.event.tickets[0].ticketId, this.event.title, this.event.personalNumber, this.tiket.assignedEmpId, this.event.uKey);
            //this.sendMessage(this.event.tickets[0].ticketId, this.event.title, '9933890285', this.tiket.assignedEmpId, this.event.uKey);
            this.event.ownerEmp = `${this.employee.firstName} ${this.employee.lastName} ${this.employee.secondLastName}`;
            this.onClose.next(this.event);
            this.bsModalRef.hide();
          }
        },
        (errMessage) => this.handleError = errMessage.messages);
    return addEventObservable;
  }

  private addTicket(): Observable<IResult> {
    if (this.resource == null) {
      this.configGeneral.newToast('¡Error!', 'Seleccione una falla o incidente de la lista para poder continuar', 'error');
      return;
    }

    this.tiket.ticketSubCategoryId = this.resource.ticketSubCategoryId;
    this.tiket.ticketCategoryId = this.resource.ticketCategoryId;
    this.tiket.allocatorEmpId = this.resource.managerEmpId;

    this.tiket.assignedEmpId = this.resource.reviewerType == 'User' ? this.resourceLocation.managerEmpId : this.employee.bossId;
    this.tiket.locationId = this.location.locationId;
    this.tiket.ownerEmpId = this.employee.id;
    this.tiket.priority = 'Baja';
    this.tiket.status = 1;
    this.tiket.eventId = this.eventId;
    this.tiket.type = 'Incident';
    const addTicketObservable = this.incidentService.addTicket(this.tiket);
    addTicketObservable
      .subscribe(
        (x) => {
          this.result = x;
          if (this.result.isCorrect === true) {
            this.tiket = this.result.data as IDtoTicket;
            this.tiket.ownerEmp = `${this.employee.firstName} ${this.employee.lastName} ${this.employee.secondLastName}`;
            this.tiket.reviewerType = this.resource.reviewerType;
            //this.sendMessage(this.tiket.ticketId, this.tiket.title, '9933890285', this.tiket.assignedEmpId, this.tiket.uKey);
            this.sendMessage(this.tiket.ticketId, this.tiket.title, this.tiket.personalNumber, this.tiket.assignedEmpId, this.tiket.uKey);
            this.onClose.next(this.tiket);
            this.bsModalRef.hide();
          }
        },
        (errMessage) => this.handleError = errMessage.messages);
    return addTicketObservable;
  }

  private handleError(error: any) {
    this.errorReceived = true;
    return Observable.throw(error);
  }
  private sendMessage(ticketId: number, title: string, personalNumber: string, assignedEmpId: number, uKey: string): void {
    this.employeeService.getBusinessPhone(uKey)
      .subscribe(
        (x) => {
          this.businessPhone = x;
          let dto = {} as IDtoMessageDetail;
          dto.recipientId = x == null ? personalNumber : x;
          dto.messageSent = `usted tienen asignado un incidente con número de folio ${ticketId} y asunto ${title}. Favor de acceder a http://rednovation.azurewebsites.net/ para su atención.`;
          dto.employeeId = assignedEmpId;
          dto.template = 'incidente_nuevo';
          this.messageService.sendMessage(dto)
            .subscribe(
              (x) => {
              },
              (errMessage) => {
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
              });
        },
        (errMessage) => {
          this.configGeneral.newToast('Error', errMessage.message, 'error');
        });
  }
}
